module.exports = {
  siteTitle: "Suliman Al Ruz - Software Engineer", // <title>
  shortSiteTitle: "Suliman Al Ruz - Software Engineer", // <title> ending for posts and pages
  siteDescription: "Expert in Spring Framework AWS Serverless Lambda Android React web development Microservices Java 8 EcmaScript 8 Backend Frontend developer consultant teacher writer Infrastructure as code CloudFormation cloud technologies NoOps DevOps programming development mobile devices web application ",
  siteUrl: "https://sulimanalruz.com",
  // pathPrefix: "",
  siteImage: "preview.jpg",
  siteLanguage: "en",

  /* author */
  authorName: "Suliman Al Ruz",
  authorTwitterAccount: "sulimanruz",

  /* info */
  headerTitle: "Suliman Al Ruz",
  headerSubTitle: "Software Engineer",

  /* manifest.json */
  manifestName: "Suliman Al Ruz - Software Engineer",
  manifestShortName: "Suliman Al Ruz ", // max 12 characters
  manifestStartUrl: "/",
  manifestBackgroundColor: "white",
  manifestThemeColor: "#7e7e7e",
  manifestDisplay: "standalone",

  // gravatar
  // Use your Gravatar image. If empty then will use src/images/jpg/avatar.jpg
  // Replace your email adress with md5-code.
  // Example https://www.gravatar.com/avatar/g.strainovic@gmail.com ->
  // gravatarImgMd5: "https://www.gravatar.com/avatar/1db853e4df386e8f699e4b35505dd8c6",
  gravatarImgMd5: "",

  // social
  authorSocialLinks: [
    { name: "github", url: "https://github.com/springsuliman" },
    { name: "twitter", url: "https://twitter.com/sulimanalruz" },
    { name: "facebook", url: "https://facebook.com/sulimanruz" }
  ],
  recaptcha_key: '6LcR9JcUAAAAAAF-LuYIRcmNyqv5vXOB_jz0G0By'

};
